import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import AllergiesandMedication from '../../components/BookConsultNow/Components/PatientMedicalComponent/Components/AllergiesandMedication/AllergiesandMedication';
import LifestyleAndPreExistingCondition from '../../components/BookConsultNow/Components/PatientMedicalComponent/Components/LifestyleAndPreExistingCondition/LifestyleAndPreExistingCondition';
import PatientVitals from '../../components/BookConsultNow/Components/PatientMedicalComponent/Components/Patient Vitals/PatientVitals';

function MedicalHistoryRoutes({ setActiveTop }) {

    let { path, url } = useRouteMatch();

    return (

        <Switch>

            <Route
                exact
                path={`${path}`}
                component={PatientVitals}
            />


            <Route
                exact
                path={`${path}/patientvitals`}
                component={PatientVitals}
            // component={BookConsultNow}
            />
            <Route
                exact
                path={`${path}/lifestyle`}
                component={LifestyleAndPreExistingCondition}
            />
            <Route
                exact
                path={`${path}/allergies`}
                component={AllergiesandMedication}
            />





        </Switch>
    )
}

export default MedicalHistoryRoutes